import {createApp} from 'vue/dist/vue.esm-bundler';
import BookHouse from 'views/order/assets/components/bookHoouse/BookHouse.vue'
import './index.scss';

class ViewSiteCheckout {

    #data = {};

    constructor(data) {
        this.#data = data;

        this.init();
    }

    init() {
        let app = createApp({
            data: () => ({
                attributesParams: this.#data.attributesParams,
                defaultTimeStart: this.#data.defaultTimeStart,
                defaultTimeEnd: this.#data.defaultTimeEnd,
                busyDatesFuture: this.#data.busyDatesFuture,
                sumPrepayment: this.#data.sumPrepayment,
                endpoints: this.#data.endpoints
            }),
            mounted() {
            }
        })
        app.component('book-house', BookHouse);
        app.mount('#main-page');
    }
}

export default (data) => new ViewSiteCheckout(data)
